import React, { useEffect, useContext, useState } from 'react'
import { ErpClientContext } from '../../services/erp'
import { Select, message, Input, Form, Button, Pagination } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import './index.css'
import { sleep } from '@guillotinaweb/react-gmi'

const { Option } = Select

function orderListByKey(data, key, order) {
  const compareValues = (key, order = 'asc') => (elemA, elemB) => {
    if (!elemA.hasOwnProperty(key) || !elemB.hasOwnProperty(key)) return 0
    const comparison = elemA[key].localeCompare(elemB[key])
    return order === 'desc' ? comparison * -1 : comparison
  }
  return data.sort(compareValues(key, order))
}

export default function MatchProducts() {
  const erpService = useContext(ErpClientContext)
  const [proveedores, setProveedores] = useState([])
  const [columnsTable, setColumnsTable] = useState([])
  const [totalProductos, setTotalProductos] = useState(0)
  const [loading, setLoading] = useState(false)
  const [proveedorSelected, setPorveedorSelected] = useState()
  const [botellas, setBotellas] = useState([])
  const [opcionBotella, setOpcionBotella] = useState({})
  const [form] = Form.useForm()

  // Estado para la paginación
  const [currentPage, setCurrentPage] = useState(1)
  const [productsPerPage, setProductsPerPage] = useState(10)

  // Estado para los valores del formulario
  const [formValues, setFormValues] = useState({})

  // Estado para la búsqueda
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredProducts, setFilteredProducts] = useState([])

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (columnsTable) {
      const filtered = columnsTable.filter((product) =>
        product.nombre.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setFilteredProducts(filtered)
    }
  }, [searchTerm, columnsTable])

  async function init() {
    const res = await erpService.getProvidersMarketplace()
    setProveedores(res)
  }

  async function getProductsProviderMarketplace(value) {
    if (value) {
      const res = await erpService.fetch('/@products-proveedores-marketplace', {
        method: 'POST',
        body: JSON.stringify({ id_proveedor: value }),
      })

      const response = await res.json()

      if (res.status >= 300) {
        message.error(
          `Failure to obtain products from supplier: ${JSON.stringify(
            response
          )}`
        )
      } else {
        console.log(response)
        setTotalProductos(response.total_productos)
        setColumnsTable(response.productos)
        setFilteredProducts(response.productos) // Inicializar productos filtrados
        setBotellas(response.botellas)
        setPorveedorSelected(value)
        setCurrentPage(1) // Resetear la página actual al obtener nuevos productos
        setFormValues({}) // Resetear los valores del formulario
      }
    }
  }

  async function onFinish(values) {
    if (values) {
      const allValues = { ...formValues, ...values }
      console.log(allValues)
      setLoading(true)
      const res = await erpService.fetch('/@match-products-marketplace', {
        method: 'POST',
        body: JSON.stringify({
          id_proveedor: proveedorSelected,
          productos: allValues,
          botellas: opcionBotella,
        }),
      })

      if (res.status >= 300) {
        const messageError = await res.json()
        message.error(`Matching error: ${JSON.stringify(messageError.message)}`)
      } else {
        message.success('Successfully completed match!')
        await sleep(500)
        setOpcionBotella({})
        await getProductsProviderMarketplace(proveedorSelected)
        form.resetFields()
        setFormValues({})
      }

      setLoading(false)
    }
  }

  function setBottleProduct(value, product) {
    setOpcionBotella({ ...opcionBotella, [product]: value[0] })
  }

  // Guardar los valores del formulario al cambiar de página
  const handleValuesChange = (changedValues, allValues) => {
    setFormValues({ ...formValues, ...allValues })
  }

  // Calcular los productos para la página actual
  const indexOfLastProduct = currentPage * productsPerPage
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  )

  // Cambiar de página
  const handleChangePage = (page) => {
    setCurrentPage(page)
    form.setFieldsValue(formValues)
  }

  // Cambiar cantidad de productos por página
  const handleChangeProductsPerPage = (value) => {
    setProductsPerPage(value)
    setCurrentPage(1) // Resetear a la primera página cuando se cambia la cantidad por página
  }

  // Limpiar búsqueda
  const clearSearch = () => {
    setSearchTerm('')
    setFilteredProducts(columnsTable)
  }

  return (
    <div
      className="container"
      style={{
        backgroundColor: '#fff',
        padding: '30px',
      }}
    >
      <div className="level-left">
        <h2 className="title is-size-5">Check marketplace products</h2>
      </div>
      <Select
        showSearch
        defaultValue="Select supplier"
        key="id_proveedor"
        onChange={(value) => {
          getProductsProviderMarketplace(value)
        }}
        style={{
          width: 250,
          marginTop: 10,
        }}
      >
        {orderListByKey(proveedores, 'nombre').map((optionCol) => (
          <Option key={optionCol.id_proveedor} value={optionCol.id_proveedor}>
            {optionCol.nombre}
          </Option>
        ))}
      </Select>
      <div
        style={{
          marginTop: 20,
        }}
      >
        Total products: {totalProductos}
      </div>
      <div style={{ marginTop: '10px' }}>
        {columnsTable.length > 0 ? (
          <div style={{ marginBottom: '10px' }}>
            <div
              style={{
                marginTop: '10px',
                position: 'relative',
                width: '250px',
              }}
            >
              <Input
                placeholder="Search product"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: '100%' }}
              />
              {searchTerm && (
                <div
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    backgroundColor: '#e0e0e0',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    transition: 'background-color 0.3s',
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#bdbdbd')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = '#e0e0e0')
                  }
                >
                  <CloseOutlined style={{ fontSize: 14, color: '#555' }} />
                </div>
              )}
            </div>
            <div style={{ marginTop: '10px' }}>
              <Form
                onFinish={onFinish}
                form={form}
                onValuesChange={handleValuesChange}
              >
                <div className="Table">
                  <div className="Heading">
                    {proveedorSelected === 'vnl' ? (
                      <div className="Cell">Familia producto</div>
                    ) : null}
                    <div className="Cell">Id producto proveedor</div>
                    <div className="Cell">Nombre producto</div>
                    {proveedorSelected === 'vnl' ? (
                      <div className="Cell">Añada producto</div>
                    ) : null}
                    {proveedorSelected === 'cab' ? (
                      <div className="Cell">GRUPO producto Vinissimus</div>
                    ) : (
                      <div className="Cell">Id producto Vinissimus</div>
                    )}
                    <Form.Item>
                      <Button
                        type="primary"
                        style={{ marginLeft: 10 }}
                        htmlType="submit"
                        loading={loading}
                      >
                        Match
                      </Button>
                      <Button
                        type="dashed"
                        htmlType="button"
                        onClick={() => window.location.reload(false)}
                        style={{
                          marginLeft: 2,
                        }}
                      >
                        Reset
                      </Button>
                    </Form.Item>
                  </div>
                  {currentProducts.map((val, index) => (
                    <div className="Row" key={index}>
                      {proveedorSelected === 'vnl' ? (
                        <div className="Cell">{val.familia_producto}</div>
                      ) : null}
                      <div className="Cell">{val.id_producto_proveedor}</div>
                      <div className="Cell">{val.nombre}</div>
                      {proveedorSelected === 'vnl' ? (
                        <div className="Cell">{val.anyada}</div>
                      ) : null}
                      <div className="Cell">
                        <Form.Item name={val.id_producto_proveedor}>
                          <Input
                            maxLength={proveedorSelected === 'cab' ? 300 : 7}
                            placeholder={
                              proveedorSelected === 'cab'
                                ? 'grupo producto'
                                : 'id_producto'
                            }
                          />
                        </Form.Item>
                      </div>
                      {botellas ? (
                        <div className="Cell">
                          <Form.Item>
                            <Select
                              showSearch
                              defaultValue="75"
                              key="id_botella"
                              style={{
                                width: 150,
                                marginTop: 10,
                              }}
                              onChange={(value) => {
                                setBottleProduct(value, Object.keys(val))
                              }}
                            >
                              {botellas.map((optionCol, index) => (
                                <Option
                                  key={index}
                                  value={Object.keys(optionCol)}
                                >
                                  {Object.keys(optionCol)}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: 20, textAlign: 'center' }}>
                  <Pagination
                    current={currentPage}
                    total={filteredProducts.length}
                    pageSize={productsPerPage}
                    onChange={handleChangePage}
                    showSizeChanger={false}
                  />
                  <Select
                    defaultValue={productsPerPage}
                    style={{ width: 120, marginTop: 10 }}
                    onChange={handleChangeProductsPerPage}
                  >
                    <Option value={10}>10 / página</Option>
                    <Option value={20}>20 / página</Option>
                    <Option value={50}>50 / página</Option>
                    <Option value={100}>100 / página</Option>
                  </Select>
                </div>
              </Form>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
